/**
 * buildInspectSnapshot — Pure read-only combat stats for HUD inspect panel.
 */
export function buildInspectSnapshot(entity) {
  if (!entity) return null;
  const eff = typeof entity.getEffectiveStats === 'function'
    ? entity.getEffectiveStats()
    : entity;
  return {
    id: entity.id,
    name: entity.name || entity.id,
    type: entity.type || 'unknown',
    team: entity.team || 'neutral',
    isDead: !!entity.isDead,
    hp: entity.hp ?? 0,
    maxHp: entity.maxHp ?? 0,
    mp: entity.mp ?? 0,
    maxMp: entity.maxMp ?? 0,
    ad: eff.ad ?? entity.ad ?? 0,
    ap: eff.ap ?? entity.ap ?? 0,
    armor: eff.armor ?? entity.armor ?? 0,
    mr: eff.mr ?? entity.mr ?? 0,
    ms: eff.ms ?? entity.ms ?? 0,
    as: eff.as ?? entity.as ?? 0,
    level: entity.level ?? 1
  };
}
